export default __webpack_public_path__ + "static/media/icn_map_pin_non_compliant.7e57dfd2.svg";